<template>
  <pull-to class="eds-message-list-root" :style="{ height: height }" :top-load-method="onAppend"
    :bottom-load-method="onRefresh" :bottom-block-height="0" :top-config="TOP_DEFAULT_CONFIG"
    :bottom-config="BOTTOM_DEFAULT_CONFIG">
    <v-layout row wrap>
      <v-card flat xs12 class="message_content" v-for="(message, index) in messageList" :key="index">
        <div v-if="
          index == 0 ||
          message.sendTime / 1000000000 -
          messageList[index - 1].sendTime / 1000000000 >
          60
        " class="message-content__time">
          {{ convertDate(message.sendTime / 1000000000).replace(/-/g, '/') }}
        </div>
        <div class="message-content__sender">
          <div class="message-content__sender--avatar">
            <v-icon :color="MESSAGES_type[message.type].color">{{
              MESSAGES_type[message.type].icon
            }}</v-icon>
          </div>
          <span class="message-content__sender--name">{{ $t(message.senderName) }}</span>
        </div>
        <v-card flat class="message_content_main" @click="onShowFlowInfo(message)">
          <!-- EDS15 -->
          <template v-if="message.data && message.data.taskID != undefined">
            <div class="message-content__title">{{ message.title }}</div>
            <div class="eds_content2">
              <span class="eds_content_prop">{{ $t('申请标题') }}</span>
              <span class="eds_content_value">{{
                message.data.flowTitle
              }}</span>
            </div>
            <div class="eds_content2">
              <span class="eds_content_prop">{{ $t('申请描述') }}</span>
              <span class="eds_content_value">{{ message.data.flowDesc }}</span>
            </div>
          </template>
          <!-- EDS16 -->
          <template v-else>
            <div class="message-content__title">{{ message.title + $t('需要您审批') }}</div>
            <div class="eds_content2">
              <span class="eds_content_prop">{{ $t('申请标题') }}</span>
              <span class="eds_content_value">{{
                message.data.workflowTitle
              }}</span>
            </div>
            <div class="eds_content2">
              <span class="eds_content_prop">{{ $t('申请描述') }}</span>
              <span class="eds_content_value">{{ message.data.workflowRemark }}</span>
            </div>
          </template>
        </v-card>
      </v-card>
    </v-layout>
  </pull-to>
</template>

<script>
import APP_CONFIG from '../../config/App'
import PullTo from 'vue-pull-to'
import iDSGoTop from '../../components/iDSGoTop'
import dateHelper from '../../util/date'
import dbHelper from '../../util/db'
import debugHelper from '../../util/debug'
import msgbus from '../../msgBus'
import { MESSAGES_TYPE } from '../../config/Message'
import functions from '../../functions'

export default {
  name: 'eDS-MessageList',
  components: {
    PullTo,
    iDSGoTop,
  },
  data() {
    return {
      TOP_DEFAULT_CONFIG: APP_CONFIG.tTOP_DEFAULT_CONFIG2(),
      BOTTOM_DEFAULT_CONFIG: APP_CONFIG.tBOTTOM_DEFAULT_CONFIG2(),
      MESSAGES_type: MESSAGES_TYPE,
      title: '', // 标题
      session: '', // 会话
      tserviceVersion: '', // 当前租户的版本
      isEDS16: false,

      event: '',
      pageIndex: 0, // 页码
      pageSize: 10, // 每页记录数
      listRecordCount: 0, // 已经加载的总记录数
      loadingText: '',

      messageList1: [
        {
          id: '5f3261bd6dd12c4ac027a800',
          sendTime: 1597029272,
          sid: '5f3261bd6dd12c4ac027a775',
          sname: '工作通知:杭州数络信息技术有限公司',
          stype: 'work',
          type: 'task_notify',
          senderID: '5f3261bd6dd12c4ac0270511',
          senderName: '流程审批',
          senderType: 'system',
          receiverID: '5f3261bd6dd12c4ac0270512',
          receiverName: '陈雪峰',
          title: '陈雪峰提交的文件解密申请',
          content: '陈雪峰提交的文件解密申请需要您处理',
          data: {
            flowID: 513,
            flowName: '陈雪峰提交的文件解密申请',
            flowTitle: '文件解密申请',
            flowDesc:
              '测试的文件解密审批流程-测试的文件解密审批流程-测试的文件解密审批流程-测试的文件解密审批流程',
            taskID: 1256,
            taskType: 'approval',
            taskCreateTime: 1597029272,
            taskState: 'awaiting',
          },
        },
        {
          id: '5f3261bd6dd12c4ac027a800',
          sendTime: 1597029272,
          sid: '5f3261bd6dd12c4ac027a775',
          sname: '工作通知:杭州数络信息技术有限公司',
          stype: 'work',
          type: 'task_notify',
          senderID: '5f3261bd6dd12c4ac0270511',
          senderName: '流程审批',
          senderType: 'system',
          receiverID: '5f3261bd6dd12c4ac0270512',
          receiverName: '陈雪峰',
          title: '陈雪峰提交的文件解密申请',
          content: '陈雪峰提交的文件解密申请需要您处理',
          data: {
            flowID: 513,
            flowName: '陈雪峰提交的文件解密申请',
            flowTitle: '文件解密申请',
            flowDesc:
              '测试的文件解密审批流程-测试的文件解密审批流程-测试的文件解密审批流程-测试的文件解密审批流程',
            taskID: 1256,
            taskType: 'approval',
            taskCreateTime: 1597029272,
            taskState: 'approved',
          },
        },
      ],
    }
  },
  computed: {
    height() {
      return `calc(${window.innerHeight}px - 48px` + ')'
    },
    isDefault() {
      return this.messageList == null || this.messageList.length == 0
    },
    messageList() {
      return [...msgbus.vm.getMessages()].reverse()
    },
    totalCount() {
      return msgbus.vm.getMessageTotalCount()
    },
  },
  methods: {
    scrollToBottom() {
      const container = this.$el.querySelector('.scroll-container')
      if (container) {
        container.scrollTop = container.scrollHeight
      }
    },
    refresh(loaded, cb) {
      // 初始加载0条记录
      this.listRecordCount = 0

      // 查询第一页消息会话
      var data = {
        order: '-sendTime',
        skip: 0,
        limit: this.pageSize,
      }
      msgbus.vm
        .fetchMessages({
          authorization: {
            Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
          },
          sessionID: this.session.id,
          data: data,
          vm: msgbus.vm,
        })
        .then(
          () => {
            this.listRecordCount += this.pageSize
            if (loaded != null) {
              loaded('done')
            }
            if (typeof cb === 'function') {
              cb()
            }
          },
          () => {
            if (loaded != null) {
              loaded('done')
            }
          }
        )
    },
    // 刷新
    onRefresh(loaded) {
      this.refresh(loaded)
    },
    // 翻页
    onAppend(loaded) {
      if (this.listRecordCount < this.totalCount) {
        let scrollHeight = 0
        const container = this.$el.querySelector('.scroll-container')
        if (container) {
          scrollHeight = container.scrollHeight
        }

        this.loadingText = this.$t('加载中...')
        // 查询下一页消息会话
        var data = {
          order: '-sendTime',
          skip: this.listRecordCount,
          limit: this.pageSize,
        }
        msgbus.vm
          .appendMessages({
            authorization: {
              Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
            },
            sessionID: this.session.id,
            data: data,
            vm: msgbus.vm,
          })
          .then(
            () => {
              this.listRecordCount += this.pageSize
              if (loaded != null) {
                loaded('done')
              }
              if (container) {
                this.$nextTick((_) => {
                  container.scrollTop = Math.max(
                    0,
                    container.scrollHeight - scrollHeight
                  )
                })
              }
            },
            () => {
              if (loaded != null) {
                loaded('done')
              }
            }
          )
      } else {
        if (loaded != null) {
          loaded('fail')
        }
        this.loadingText = this.$t('已经到顶了')
      }
    },

    // 转化时间
    convertDate(updateTime) {
      return dateHelper.timestamp2LocalTime(updateTime)
    },
    // 显示流程
    onShowFlowInfo(message) {
      var scroll = document.getElementsByClassName('scroll-container')[0]
      debugHelper.log('存储scrollTop : ' + scroll.scrollTop)
      dbHelper.set('listScrollTop', scroll.scrollTop)
      dbHelper.set('listRecordCount', this.listRecordCount)

      let routerName = this.isEDS16 ? 'flowinfo16' : 'flowinfo'
      let flowID = message.data.flowID != undefined ? message.data.flowID : message.data.workflowID
      this.$router.push({
        name: routerName,
        params: {
          flowID: flowID,
          flowTid: this.session.cid,
        },
      })
    },
    // 切换界面样式
    changeView() {
      msgbus.vm.setTitle(this.title)
      msgbus.vm.setTitleVisible(true)
      msgbus.vm.setBackDisabled(false)
      msgbus.vm.setBackIcon('arrow_back')
      msgbus.vm.setBottomNavVisible(false)
      msgbus.vm.setBottomBtnVisible(false)
      msgbus.vm.setMsgInputVisible(false)
      msgbus.vm.setContentHeight({
        value: `calc(${window.innerHeight}px - 48px ` + ')',
      })
    },
  },
  created() {
    console.log('调试代码')
    if (msgbus.vm.getAccountToken() == null) {
      window.location.href = '/'
      return
    }

    // 如果有路由参数，则读取路由参数：当前会话信息，否则从store中读取当前会话信息
    if (this.$route.params.session) {
      this.session = this.$route.params.session
      msgbus.vm.setCurrentSession({ value: this.session })
    } else {
      this.session = msgbus.vm.getCurrentSession()
    }

    this.title = this.session.cid
      ? functions.login.funcGetTnameBaseTid(this.session.cid)
      : this.$t('系统公告')

    // 确定当前消息列表对应的租户版本
    var tenants = msgbus.vm.getAccountTenants()
    let index = tenants.findIndex(item => item.id == this.session.cid)
    if (index != -1) {
      this.tserviceVersion = tenants[index].serviceVersion
      this.isEDS16 = this.tserviceVersion.match(APP_CONFIG.RgxEDS16_Version)
    }

    // 读取页面加载的总记录数
    var listRecordCountTmp = parseInt(dbHelper.get('listRecordCount'))
    this.listRecordCount = isNaN(listRecordCountTmp) ? 0 : listRecordCountTmp
    if (msgbus.vm.getMessages().length == 0 || this.listRecordCount == 0) {
      // 显示信息
      this.refresh(null, () => {
        this.scrollToBottom()
      })
    } else {
      this.event = 'updateScrollTop'
      if (this.listRecordCount < this.totalCount) {
        this.loadingText = this.$t('加载中...')
      } else {
        this.loadingText = this.$t('已经到顶了')
      }
    }

    // 切换界面样式
    this.changeView()
  },
  mounted() {
    debugHelper.log(this.event)
    switch (this.event) {
      case 'updateScrollTop':
        var scroll = document.getElementsByClassName('scroll-container')[0]
        var Top = dbHelper.get('listScrollTop')
        debugHelper.log('获取scrollTop : ' + Top)
        scroll.scrollTop = Top
        dbHelper.set('listScrollTop', 0)
        dbHelper.set('listRecordCount', 0)
        break
    }
    this.event = ''
  },
  updated() {
    debugHelper.log(this.event)
    switch (this.event) {
      case 'updateScrollTop':
        var scroll = document.getElementsByClassName('scroll-container')[0]
        var Top = dbHelper.get('listScrollTop')
        debugHelper.log('获取scrollTop : ' + Top)
        scroll.scrollTop = Top
        dbHelper.set('listScrollTop', 0)
        dbHelper.set('listRecordCount', 0)
        break
    }
    this.event = ''
  },
  beforeDestroy() {
    msgbus.vm.setMenuDisabled(true)
    msgbus.vm.setMenuItems([])
    msgbus.vm.setMenuIcon('')
  },
}
</script>


<style lang="scss">
.eds-message-list-root {
  background: #f3f4f6;

  & .layout {
    background: #f3f4f6;
    padding-bottom: 20px !important;
  }

  &>.scroll-container {
    display: flex;
    flex-direction: column;
    background: #f3f4f6;

    &>.eds_no_info_outer {
      flex: 1;
      display: block;
      position: relative;

      &>.eds_no_info_inner {
        display: inline-block;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }

  .message_content {
    background: inherit;
    width: 100%;
    padding: 10px 0;

    .message-content__time {
      color: #8a8a8f;
      font-size: 14px;
      text-align: center;
    }

    .message-content__sender {
      .message-content__sender--avatar {
        margin: 0 12px;
        display: inline-block;
        width: 36px;
        height: 36px;
        padding: 8px 10px;
        border-radius: 50%;
        background: #54de73;

        &>.v-icon {
          color: #ffffff !important;
          width: 16px;
          height: 16px;
          font-size: 20px;
        }
      }

      .message-content__sender--name {
        color: #505050;
        font-size: 14px;
      }
    }

    .message_content_main {
      margin: 0 40px 0 60px;
      padding: 3px 10px 10px 10px;
      border-radius: 12px !important;

      .message-content__state {
        position: absolute;
        top: 16px;
        right: 8px;
        z-index: 9999;
      }

      .message-content__title {
        font-size: 14px;
        font-weight: bold;
        padding: 5px 0;
      }
    }
  }
}
</style>
